import { Component, OnInit } from '@angular/core';
import { PosterService } from 'src/app/_services/generatedServices';
import { PosterViewModel } from 'src/app/_models/generatedModels';
import { NavigationService } from 'src/app/_services/navigation-service';

@Component({
  selector: 'bxl-my-posters',
  templateUrl: 'my-posters.component.html',
})
export class MyPostersComponent implements OnInit {
  initialized = false;
  posters: PosterViewModel[];
  constructor(private posterService: PosterService, private nav: NavigationService) {
    this.nav.pageTitle = 'My Posters';
  }

  ngOnInit(): void {
    this.posterService.getPostersForUser().subscribe(posters => {
      this.posters = posters;

      this.initialized = true;
    });
  }


}
